import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { HighlightState, HighlightTypes } from './types';

const INITIAL_STATE: HighlightState = {
    data: {
        highlightListSize: 0,
        highlightList: [],
    },
    loading: false,
    hasError: false,
};

const reducer: Reducer<HighlightState> = (state: HighlightState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case HighlightTypes.HIGHLIGHTS_REQUEST:
            return { ...state, loading: true, hasError: false };
        case HighlightTypes.HIGHLIGHTS_SUCCESS:
            return {
                ...state.data,
                data: {
                    highlightList: action.payload.resetData ? action.payload.data : [...state.data.highlightList].concat([...action.payload.data]),
                    highlightListSize: action.payload.listSize,
                },
                loading: false,
                hasError: false,
            };
        case HighlightTypes.HIGHLIGHTS_FAILURE:
            return { ...state, loading: false, hasError: true };
        case HighlightTypes.SEND_HIGHLIGHT_REQUEST:
            return { ...state, loading: true, hasError: false };
        case HighlightTypes.SEND_HIGHLIGHT_SUCCESS:
            return {
                ...state,
                hasError: false,
            };
        case HighlightTypes.SEND_HIGHLIGHT_FAILURE:
            return { ...state, loading: false, hasError: true, data: { ...state.data } };
        case HighlightTypes.HIGHLIGHTS_CLEAR:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default reducer;
